export default __webpack_public_path__ + "static/media/3-4-3.e66f6312.jpg";